import { filter, times } from "lodash/fp";
import { useParams } from "react-router-dom";

import { styled } from "@mui/system";

import StandingsCard from "@app/analytics/MeetingReport/components/StandingsCard";
import useMeetingInfoQuery from "@app/analytics/MeetingReport/hooks/useMeetingInfoQuery";
import useMeetingReportStandings from "@app/analytics/MeetingReport/hooks/useMeetingReportStandings";
import { LoadingSkeleton } from "@app/analytics/MeetingReport/styles";
import { StandingsMetricDataWithScores } from "@app/analytics/MeetingReport/types";
import { STANDINGS_DESCRIPTIONS } from "@app/common/content";
import { isReadLite } from "@app/common/utils";

import Stack from "@rui/Stack";

const FREE_METRICS = [
  "participantEngagement",
  "microphoneOffPercent",
  "cameraOffPercent",
];

const OBJECTIVE_METRICS = ["microphoneOffPercent", "cameraOffPercent"];

const StyledStack = styled(Stack)({ width: "100%" });

const StandingsModule = () => {
  const { sessionId } = useParams();
  const { loading: dataIsLoading, metrics } = useMeetingReportStandings(
    sessionId!
  );

  const { data: meetingInfo, isInitialLoading: meetingInfoIsLoading } =
    useMeetingInfoQuery(sessionId);
  if (!sessionId) return null;

  if (dataIsLoading || meetingInfoIsLoading) {
    return (
      <StyledStack spacing={1}>
        {times(
          (i) => (
            <LoadingSkeleton key={i} height={78} />
          ),
          7
        )}
      </StyledStack>
    );
  }

  const sessionIsLite = meetingInfo ? isReadLite(meetingInfo) : false;
  const standingMetrics =
    meetingInfo?.metricsLevel === "objective_metrics"
      ? filter((metric) => OBJECTIVE_METRICS.includes(metric.id!), metrics)
      : metrics;

  return (
    <StyledStack spacing={1}>
      {standingMetrics.map(
        ({ id, ...metricItem }: StandingsMetricDataWithScores) => (
          <StandingsCard
            key={id}
            id={id}
            {...metricItem}
            subtitle={STANDINGS_DESCRIPTIONS[id!]}
            locked={sessionIsLite && !FREE_METRICS.includes(id!)}
          />
        )
      )}
    </StyledStack>
  );
};

export default StandingsModule;
